import { KycStatus } from "types/BETypes";

import { UserProfileResponseDto } from "utils/swagger_react_query";

export const isKycAccepted = (user?: Partial<UserProfileResponseDto> | null | undefined) => {
  return (
    user?.activeCompanyUser?.kycStatus === KycStatus.ACCEPTED &&
    user?.activeCompanyUser?.hasPersonalBankAccount
  );
};

export const isKycRejected = (user?: Partial<UserProfileResponseDto> | null | undefined) => {
  return user?.activeCompanyUser?.kycStatus === KycStatus.REJECTED;
};

export const isKycPending = (user?: Partial<UserProfileResponseDto> | null | undefined) => {
  return (
    user?.activeCompanyUser?.kycStatus === KycStatus.PENDING ||
    user?.activeCompanyUser?.kycStatus === KycStatus.REVIEW ||
    user?.activeCompanyUser?.kycStatus === KycStatus.PROVISIONAL
  );
};
